import { useGLTF } from "@react-three/drei"

function CloudsLoader() {
  const { nodes, materials } = useGLTF(
    `${process.env.PUBLIC_URL}/assets/apartmentfinder/clouds/scene.gltf`
  )
  //   console.log(materials)

  const cloudPos = [
    [-23320.548068, 94107.765475, 40429.877967],
    [240906.107705, 96317.812911, 33091.251895],
    [68659.172085, 262827.93633, 28327.973407],
    [141596.150296, -46673.645864, 44708.941052],
    [107775.11193, 73634.052797, 27188.092671],
    [208947.263847, 220885.365911, 31141.60816],
    [-21177.871616, 200954.817163, 41050.809224],
    [125805.569153, 173959.098536, 33918.933579],
    [26094.910271, -14739.656114, 29507.663079],
    [172812.270041, 19118.971229, 25232.133059],
    [42449.055162, 124557.682843, 40315.346813],
    [67083.731421, 200525.009533, 25582.871814],
    [151065.341706, 244645.008418, 25159.22381],
    [190540.969524, 149644.04427, 35208.448339],
    [88396.689425, 14224.393302, 32649.899692],
    [-7885.091337, 37092.554097, 30596.175666],
    [47407.20269, 72097.973288, 39069.765882],

    [225618.710991, 3844.917466, 42000.79243],
    [41839.428825, 159387.752107, 38749.858105],
    [102113.206772, 251624.863219, 39888.042856],
    [10872.70124, 76017.313947, 38720.913251],
    [-9240.173404, -4700.859675, 26869.226457],
    [90507.427433, 163564.972576, 25818.422078],
    [51580.57378, -46366.619888, 30440.403751],
    [90100.2971, -15843.58637, 30273.022528],
    [162955.493872, -9382.871486, 35003.589699],
    [193874.293719, 52242.908272, 44239.398105],
    [53108.559257, 233328.306131, 36128.909327],
    [238355.80724, 189577.303305, 25360.060162],
    [6928.221371, 118589.833097, 34778.811549],
    [130400.758735, 97365.849683, 31852.249175],
    [76358.157428, 85879.019977, 34721.069633],
    [-34091.134153, 168809.509006, 37856.640258],
    [208111.274607, 81934.074802, 37410.554821],
    [113121.393288, 35988.609956, 26474.906816],
    [28762.12905, 50162.677472, 42916.43753],
    [241786.485157, 68868.144616, 36915.455256]
  ]

  const cloudObjects = []

  const nodesArr = Object.values(nodes)
  const materialsArr = Object.values(materials)
  //   console.log(materialsArr)
  materialsArr.map(m => (m.doubleSided = true))
  //   console.log(materialsArr)

  nodesArr.map(n => {
    if (n.type === "Mesh") cloudObjects.push(n)
    return null
  })

  return (
    <>
      {cloudPos.map((c, i) => (
        <mesh
          position={[cloudPos[i][0], cloudPos[i][2], -cloudPos[i][1]]}
          rotation={[Math.PI / 2, 0, Math.PI * Math.random()]}
          scale={Math.random() * 190}
          material={cloudObjects[i % 1].material}
          geometry={cloudObjects[i % 1].geometry}
        />
      ))}
    </>
  )
}

export default CloudsLoader
